import InformationHover from "components/InformationHover";
import React from "react";

const SingleBookingInformation = () => {
    return (
        <span className="flex items-center gap-3">
            <p>Hantera extra information och tillägg</p>
            <InformationHover>
                <div className="text-left w-full">
                    <p>
                        För att hantera extra information och tillägg kommer du
                        att hamna i ett separat flöde utanför Batch.
                    </p>
                    <p>Exempel på information och tillägg:</p>
                    <ul className="list-disc pl-6">
                        <li>Tull</li>
                        <li>Tilläggstjänster</li>
                        <li>Försäkring</li>
                        <li>Upphämtning-/Leveransinstruktioner</li>
                        <li>Mottagarfrakt</li>
                    </ul>
                </div>
            </InformationHover>
        </span>
    );
};

export default SingleBookingInformation;
